import ScaledContent from "library/ScaledContent"
import { fresponsive } from "library/fullyResponsive"
import styled, { css } from "styled-components"
import colors from "styles/colors"

import Blog from "./Blog"
import Centralize from "./Centralize"
import Compare from "./Compare"
import Control from "./Control"
import FacilitiesMore from "./FacilitiesMore"
import FacilitiesThree from "./FacilitiesThree"

export type IconVariant =
	| "centralize"
	| "compare"
	| "control"
	| "facilitiesThree"
	| "facilitiesMore"
	| "blog"

export default function AnimatedIcon({
	variant,
	small = false,
}: {
	small?: boolean
	variant: IconVariant
}) {
	let output: JSX.Element | undefined

	switch (variant) {
		case "centralize":
			output = <Centralize />
			break

		case "compare":
			output = <Compare />
			break

		case "control":
			output = <Control />
			break

		case "facilitiesThree":
			output = <FacilitiesThree />
			break

		case "facilitiesMore":
			output = <FacilitiesMore />
			break

		case "blog":
			output = <Blog />
			break

		default:
			variant satisfies never
	}

	if (small)
		return (
			<ScaledContent scale={0.615_384_615_4}>
				<Wrapper>{output}</Wrapper>
			</ScaledContent>
		)

	return <Wrapper>{output}</Wrapper>
}

const Wrapper = styled.div`
	${fresponsive(css`
		position: relative;
		overflow: clip;
		width: 65px;
		height: 65px;
		border-radius: 8px;
		border: 1px solid ${colors.blue3};
		background: ${colors.transBlue1};
	`)}
`
